import { useEffect,useState } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import { useEntityCrud } from '../../../hooks/useEntityCrud';

import './Style.css';
import { toast } from 'react-toastify';

const Show = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const { readData } = useEntityCrud('Support/getSupportRequest');
    const { addData } = useEntityCrud('Support/setSupportRequest');
    const { addData: close } = useEntityCrud(`Support/closeSupportRequest?Id=${id}`);

    const [ticket,setTicket] = useState({});
    const [isFetched,setIsFetched] = useState(false);
    const [message,setMessage] = useState('');

    const getData = () => {
        readData({id}).then(({ data }) => {
            if(data.status && data.result.length)
                setTicket(data.result.find(t => t.id == id));
        }).finally(() => {
            setIsFetched(true);
        })
    }

    useEffect(() => {
        getData();
    },[])

    const addAnswer = () => {
        const postedData = {
            id,
            ticketMessage: message
        }
        addData(postedData).then(({data}) => {
            if(data.status){
                toast.success('پاسخ جدید با موفقیت ثبت شد');
                getData();
                setMessage('');
            }else
                data.errors.map(error => toast.error(error.message))
        })
    }

    const closeTicket = () => {
        close().then(({data}) => {
            if(data.status){
                toast.success('درخواست پشتیبانی با موفقیت بسته شد');
                getData();
            }else
                data.errors.map(error => toast.error(error.message))
        })
    }
    
    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">مشاهده تیکت {id}</div>
                <a className="backIconLink" onClick={() => navigate(-1)}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            {Object.keys(ticket).length ? <div className="card-body p-4">
                <div className="table-responsive">
                    <table className="table table-bordered table-hover mb-1">
                        <tbody>
                            <tr style={{lineHeight: '30px'}}>
                                <td>نام کاربر :</td>
                                <td>{ticket.issuerFullName}</td>
                            </tr>
                            <tr style={{lineHeight: '30px'}}>
                                <td>کد ملی</td>
                                <td>{ticket.nationalCode}</td>
                            </tr>
                            <tr style={{lineHeight: '30px'}}>
                                <td>موضوع :</td>
                                <td>{ticket.topicTitle}</td>
                            </tr>
                            {ticket.businessName ? <tr style={{lineHeight: '30px'}}>
                                <td>کسب و کار :</td>
                                <td>{ticket.businessName}</td>
                            </tr> : ''}
                            <tr style={{lineHeight: '30px'}}>
                                <td>وضعیت :</td>
                                <td>{ticket.statusTitle}</td>
                            </tr>
                            <tr style={{lineHeight: '30px'}}>
                                <td>تاریخ ثبت</td>
                                <td>{new Date(ticket.insertDate).toLocaleDateString('fa-IR')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <hr className="mb-5" />
                {ticket.supportTickets.map(message => <div className={`message-row ${![83,103].includes(message.issuerRole) ? 'odd' : 'even'}`}>
                    <div className="message-item">
                        <span className="message-item-name">{message.userFullName}</span>
                        <span className="message-item-date" dir="ltr">{new Date(message.insertDate).toLocaleDateString('fa-IR') + ' ' + new Date(message.insertDate).toLocaleTimeString('fa-IR')}</span>
                        <p>{message.ticketMessage}</p>
                    </div>
                </div>)}
                {ticket.status != 3 ? <>
                <hr className="my-5" />
                <h6 style={{fontWeight: 'bold',fontSize: 16}} className="mb-4">ارسال پاسخ جدید</h6>
                <div className="form-group">
                    <label>متن پاسخ</label>
                    <textarea rows="6" className="form-control" value={message} onChange={e => setMessage(e.target.value)}></textarea>
                </div>
                <button className="btn btn-success" disabled={!message} onClick={addAnswer}>ارسال پاسخ</button>
                <button className="btn btn-danger ms-2" onClick={closeTicket}>بستن تیکت</button>
                </> : ''}
            </div> : (isFetched ? <div className="card-body p-4"><div className="alert alert-info mb-0"><p className="mb-0">تیکت مورد نظر یافت نشد</p></div></div> : <div className="card-body p-4"><p className="text-center">در حال بارگذاری ...</p></div>)}
        </div>
    )
}

export default Show